<template>
    <div id="page-not-found" class="md-layout md-alignment-center-center">
        <div>
            <md-icon class="md-size-5x">error_outline</md-icon>
            <h1>PAGE NOT FOUND</h1>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageNotFound',
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
#page-not-found {
    .md-icon {
        color: #fff;
    }
}
</style>
